
<template>
	<c-dialog ref="dialog" title="选择绩效工资取数维度" width="600" height="500" enable-flex @resolve="resolve">
		<c-table ref="list" height="grow" :data="dataList" border :paging="false">
			<c-table-column type="selector" width="32"></c-table-column>
			<c-table-column label="序号" width="35" name="index"></c-table-column>
			<c-table-column label="业务对象" width="100" name="work_type_name"></c-table-column>
			<c-table-column label="属性" width="150" name="field_title"></c-table-column>
		</c-table>
	</c-dialog>
</template>

<script>
	export default {
	    name: 'salaryDimensionSelector',
		
		computed: {
		},
	  
		data() {
			return {
				dataList:[],
				exclude_dimension_ids:[]
			}
		},
		
		props: {
			multiple: Boolean,
		},
		
		methods: {
			/**
			 * @param exclude_dimension_ids  排除该工序不返回
			 */
			open(data) {
				this.exclude_dimension_ids = data.exclude_dimension_ids||[];
				//加载列表
				this.loadData();
				//打开弹窗
				this.$refs.dialog.open();
			},

			loadData(){
				this.dataList = [];
				this.request({
					url:'/salary/match/dimension',
					data: {},
					success:data => {
						if (data){
							var count = 1;
							data.forEach((item, index) => {
								if (!this.exclude_dimension_ids.includes(item.field_id)) {
									item.index = count++;
									this.dataList.push(item);
								}
							});
						}
					}
				})
			},

			resolve(stop) {
				var selectedRows = this.$refs.list.getRow('selected');
				if (!selectedRows.length) {
					stop();
					this.$message({
						message: '请选择取数维度'
					});
					return;
				}
				this.$emit('resolve', selectedRows);
			}
		}
	}
</script>